import script from "./Collapse.vue?vue&type=script&setup=true&lang=js"
export * from "./Collapse.vue?vue&type=script&setup=true&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=84429f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84429f74"]])

export default __exports__